import axiosInstance from "./axios/axios_instance"
const http = axiosInstance("/protected",  null, "/logout")

const GetStatuses = () => http.get('/statuses')
const TestToken = (token) => http.get(`/test_token/${token}`)

export default {
    GetStatuses,
    TestToken
}